import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BYPASS_INTERCEPTOR } from 'app/core/interceptor/auth-bypass.token';

@Injectable({
  providedIn: 'root'
})

export class S1PublicService {
  params: any;
  constructor(private http: HttpClient) {}
  
  serverGetSystemVersion(): Observable<any> {
    return this.http.get<any>('private/server/version', { context: new HttpContext().set(BYPASS_INTERCEPTOR, true) });
  }

  getparams(): Observable<any> {
    return this.http.get("private/server/params", { context: new HttpContext().set(BYPASS_INTERCEPTOR, true) });
  }

}